import { combineReducers, createReduxStore, register } from "@wordpress/data";

const popup = (state = {}, action) => {
  return action.type === "SET_POPUP"
    ? {
        ...state,
        ...action.payload,
      }
    : action.type === "SET_ATTRIBUTES"
    ? { ...state, attributes: { ...state.attributes, ...action.payload } }
    : state;
};

const initialPopupValue = {
  background: "#5800FF",
  color: "#fff",
  buttonGap: "20px",
  heading: "Sorry to see you go. What made you decide not to try our product?",
  description: "Please let us know what we can do to get more people like you on our platform.",
  buttons: ["I don't need it", "I'm using a different tool", "Too expensive", "I don't see benefits"],
  CSS: "",
  uniqueId: "vstr_visitor_feedback",
  btnColor: "#fff",
  btnBG: "#3D00B2",
  headingFontsize: "20px",
  descFontSize: "16px",
  enabled: false,
};

const store = createReduxStore("visitor-feedback", {
  initialState: {
    popup: initialPopupValue,
  },
  reducer: combineReducers({
    popup,
  }),
  actions: {
    setPopup: (data) => {
      if (typeof data !== "object") {
        return {};
      }
      return {
        type: "SET_POPUP",
        payload: { ...data },
      };
    },
    setPopupData: (data) => {
      if (typeof data !== "object") {
        return {};
      }
      return {
        type: "SET_ATTRIBUTES",
        payload: { ...data },
      };
    },
    fetchPopupData: () => {
      return {
        type: "FET_POPUP_DATA",
      };
    },
  },

  // controls: {
  //   FET_POPUP_DATA: () => {},
  // },
  selectors: {
    getPopup: (state) => {
      return state.popup;
    },
    getPopupData: (state) => {
      return state.popup.data;
    },
  },
  // resolvers: {
  //   *getPopup() {

  //   },
  // },
});

register(store);
